/**
 * Single source for the course cover geometry.
 *
 * `lg` mirrors what the user-facing card renders (a CircularProgress ring); the smaller sizes keep
 * the exact same ratio so the same image reads identically in the admin list, the builder and the
 * learning suite. Inner size and padding follow CircularProgress: `size - strokeWidth * 2`, padded
 * by a quarter of that — do not diverge, or the crop shifts between views.
 */
export const COURSE_COVER = {
  sm: { size: 48, strokeWidth: 4 },
  md: { size: 64, strokeWidth: 6 },
  lg: { size: 92, strokeWidth: 8 }
} as const;

export type CourseCoverSize = keyof typeof COURSE_COVER;

export const COURSE_COVER_FALLBACK = '/user-default.svg';

export const COURSE_COVER_TRACK_COLOR = '#f5f5f7';
